import { Component } from '@angular/core';
import { ErrorService } from 'src/app/core/error.service';
import { StoreSummary, StoresService } from 'src/app/core/stores.service';

@Component({
  selector: 'app-stores-summary',
  templateUrl: './stores-summary.component.html',
  styleUrls: ['./stores-summary.component.scss'],
})
export class StoresSummaryComponent {
  is_summary_request_running: boolean = true;
  summary?: StoreSummary;

  constructor(private error_service: ErrorService, private stores_service: StoresService) {}

  ngOnInit(): void {
    this.readSummary();
  }

  onRefresh(): void {
    this.readSummary();
  }

  readSummary(): void {
    this.is_summary_request_running = true;
    this.stores_service.readSummary().subscribe({
      next: response => {
        this.summary = response.data;
        this.is_summary_request_running = false;
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_summary_request_running = false;
      },
    });
  }
}
